import * as React from "react";
const SvgFiRrTennis = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tennis_svg__a)">
      <path
        fill="#062147"
        d="M20.485 3.515a11.994 11.994 0 1 0 0 16.97 12.013 12.013 0 0 0 0-16.97m1.449 7.417a7.965 7.965 0 0 1-8.865-8.866 9.96 9.96 0 0 1 8.865 8.866M2.066 13.068a7.963 7.963 0 0 1 8.865 8.866 9.96 9.96 0 0 1-8.865-8.866m17.005 6a9.95 9.95 0 0 1-6.127 2.879 9.97 9.97 0 0 0-10.9-10.894 9.98 9.98 0 0 1 9.012-9.003 9.988 9.988 0 0 0 10.897 10.904 9.95 9.95 0 0 1-2.882 6.117z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tennis_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTennis;
